import { useAuth } from "../../context/auth-context";
import type {
  AdminPayoutSummariesData,
  AdminPayoutSummariesEnvelope,
} from "./adminPayoutSummaries";
import { apiQueryKey } from "./queryKeys";
import { useApiQuery } from "./useApiQuery";

export type UseAdminPayoutSummariesParams = {
  startDate?: string;
  endDate?: string;
  enabled?: boolean;
};

/**
 * GET api/admin/transactions/summaries?type=payouts[&startDate][&endDate]
 */
export function useAdminPayoutSummariesQuery(
  params: UseAdminPayoutSummariesParams = {}
) {
  const { isAuthenticated } = useAuth();
  const { startDate, endDate, enabled: enabledParam = true } = params;

  return useApiQuery<AdminPayoutSummariesEnvelope, AdminPayoutSummariesData>({
    queryKey: apiQueryKey("admin-transactions-summaries", {
      type: "payouts",
      startDate: startDate ?? null,
      endDate: endDate ?? null,
    }),
    url: "api/admin/transactions/summaries",
    params: {
      type: "payouts",
      startDate,
      endDate,
    },
    enabled: Boolean(isAuthenticated) && enabledParam,
    select: (body) => body.data,
  });
}
